enum BiEvent {
  NAVIGATION_REQUESTED = 'NAVIGATION_REQUESTED',
  NAVIGATION_COMPLETED = 'NAVIGATION_COMPLETED',
  EPISODE_PLAY_REQUESTED = 'EPISODE_PLAY_REQUESTED',
  EPISODE_PLAY_STARTED = 'EPISODE_PLAY_STARTED',
  EPISODE_PLAY_ERROR = 'EPISODE_PLAY_ERROR',
  FEED_LOAD_REQUESTED = 'FEED_LOAD_REQUESTED',
  FEED_LOAD_COMPLETED = 'FEED_LOAD_COMPLETED',
  FEED_LOAD_MORE_REQUESTED = 'FEED_LOAD_MORE_REQUESTED',
  FEED_LOAD_MORE_COMPETED = 'FEED_LOAD_MORE_COMPETED',
}

export { BiEvent };
